import "../App.css";
import i18next from "../i18n";

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import article_img_1 from "../images/articles/knuckles-2569234_1920.jpg";
import article_img_2 from "../images/articles/laptop-2548147_1920.jpg";
import article_img_3 from "../images/articles/people-7621238_1920.jpg";
import article_img_4 from "../images/articles/people-mobile.jpg";
import article_img_5 from "../images/articles/linkNordic-parner.jpg";
import article_img_6 from "../images/articles/CCMBankForsikring.png";
import article_img_7 from "../images/articles/navsamarbeid.jpeg";
import article_img_8 from "../images/articles/files-7252442_1920.jpeg";
import article_img_9 from "../images/articles/gjensidige_samarbeid_3.jpg";
import article_img_10 from "../images/articles/shawn-rain-qm63uPRGKIs-unsplash.jpeg";
import article_img_11 from "../images/articles/timon-studler-ABGaVhJxwDQ-unsplash.jpeg";
import article_img_13 from "../images/articles/health-docs.jpeg";
import article_img_12 from "../images/articles/vladyslav-bahara-pc15IvTUgpc-unsplash.jpeg";
import article_img_14 from "../images/articles/yngve-windsland-Y4X1vM4FVfA-unsplash.jpeg";
import article_img_15 from "../images/articles/elena-koycheva-bGeupv246bM-unsplash.jpeg";
import article_img_16 from "../images/articles/bjarne-intervju.jpeg";
import article_img_17 from "../images/articles/airplane.jpeg";
import article_img_18 from "../images/articles/RegningenKundeopplevelse.jpeg";
import article_img_19 from "../images/articles/scott-graham-5fNmWej4tAA-unsplash.jpeg";
import article_img_20 from "../images/articles/brooke-cagle--uHVRvDr7pg-unsplash.jpeg";
import article_img_21 from "../images/articles/pal-intervju.jpeg";
import article_img_22 from "../images/articles/urgent-now.jpeg";
import article_img_23 from "../images/articles/clear-documents.jpeg";
import article_img_24 from "../images/articles/matt-foxx-IUY_3DvM__w-unsplash.jpeg";
import article_img_25 from "../images/team/Suparna.png";
import article_img_26 from "../images/articles/2025-2026.png";
import article_img_27 from "../images/articles/pavel_article.jpeg";
import article_img_28 from "../images/articles/IMG_4052.jpg";

function Artikler() {

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.description")}
        />
        <link rel="canonical" href="https://xperconsulting.no/artikler" />
      </Helmet>

      <div className="container max-w-xl pt-36 justify-start items-start text-main-dark">
        <div className="w-3/5 text-left text-xl ">
          <h1 className="text-5xl font-bold text-main-dark mb-6">
            {i18next.t("pages.articles.title")}
          </h1>
        </div>
      </div>

      <Link
        className="container justify-start px-0 py-20 px-6 border-b border-main hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
        to="/artikler/intervju-jens-ugland"
      >
        <div className="flex flex-col md:flex-row  text-main-dark">
          <div className="w-full md:w-1/2 aspect-[16/9] bg-white overflow-hidden">
            <img
              className=" object-cover mt-[-120px]"
              src={article_img_28}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start md:p-6 pr-0">
            <h2 className="text-3xl font-bold mt-4 md:mt-0">
              {i18next.t("pages.articles.list.interviewJensUgland.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.interviewJensUgland.date")}
            </p>
            <p className="max-w-xs text-lg text-secondary line-clamp-4">
              {i18next.t("pages.articles.list.interviewJensUgland.sections.intro")}
            </p>
          </div>
        </div>
      </Link>

      <div className="container mx-auto flex flex-col md:flex-row flex-wrap  justify-start items-start px-0 py-8 ">
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/intervju-pavel-pajer"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className=" object-cover mt-[-35px]"
                src={article_img_27}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.interviewPavel.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.interviewPavel.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.interviewPavel.sections.intro")}
              </p>
            </div>
          </Link>
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/2026-dokumenter-del-av-strategien"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className=" object-cover mt-[-35px]"
                src={article_img_26}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.strategy2026.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.strategy2026.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.strategy2026.description")}
              </p>
            </div>
          </Link>
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/intervju-suparna"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className=" object-cover mt-[-35px]"
                src={article_img_25}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.interviewSuparna.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.interviewSuparna.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.interviewSuparna.sections.intro")}
              </p>
            </div>
          </Link>
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/praktisk-veikart-pdf"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className="w-full h-full object-cover"
                src={article_img_24}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.roadmapPDF.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.roadmapPDF.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.roadmapPDF.description")}
              </p>
            </div>
          </Link>
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/klare-dokumenter-skaper-tryggere-bomiljoer"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className="w-full h-full object-cover"
                src={article_img_23}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.clearDocuments.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.clearDocuments.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.clearDocuments.description")}
              </p>
            </div>
          </Link>
   
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/intervju-paal-vinland"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className="w-full  object-cover mt-[-50px]"
                src={article_img_21}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.interviewPaalVinland.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.interviewPaalVinland.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.interviewPaalVinland.sections.intro")}
              </p>
            </div>
          </Link>
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/tydelig-kommunikasjon-styrker-studentopplevelsen"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className="w-full h-full object-cover"
                src={article_img_20}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.studentExperience.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.studentExperience.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.studentExperience.description")}
              </p>
            </div>
          </Link>
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/hva-koster-det-a-la-vaere"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className="w-full h-full object-cover"
                src={article_img_19}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.costOfIgnoring.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.costOfIgnoring.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.costOfIgnoring.description")}
              </p>
            </div>
          </Link>
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/nar-regningen-blir-del-av-kundeopplevelsen"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden ">
              <img
                className="w-full  object-cover mt-[-50px]"
                src={article_img_18}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.energyBillExperience.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.energyBillExperience.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.energyBillExperience.description")}
              </p>
            </div>
          </Link>
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/hvorfor-haster-det-na"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className="w-full h-full object-cover"
                src={article_img_22}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.urgentNow.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.urgentNow.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.urgentNow.description")}
              </p>
            </div>
          </Link>
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/intervju-bjarne-sorum"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className="w-full  object-cover mt-[-50px]"
                src={article_img_16}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.interviewBjarne.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.interviewBjarne.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.interviewBjarne.description")}
              </p>
            </div>
          </Link>
        <Link
            className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
            to="/artikler/trygghet-pa-reisen-tydelig-kommunikasjon"
          >
            <div className="w-full aspect-[16/9] bg-white overflow-hidden">
              <img
                className="w-full h-full object-cover"
                src={article_img_17}
                alt=""
              ></img>
            </div>
            <div className="flex flex-col text-left items-start">
              <h2 className="text-2xl font-bold mt-2">
                {i18next.t("pages.articles.list.transportTravel.title")}
              </h2>
              <p className="text-sm text-secondary mb-0">
                {i18next.t("pages.articles.list.transportTravel.date")}
              </p>
              <p className="max-w-xs text-md text-secondary line-clamp-2">
                {i18next.t("pages.articles.list.transportTravel.description")}
              </p>
            </div>
          </Link>
        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/kundedokumenter-kundeservice-telekom"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_15}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.customerDocsTelecom.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.customerDocsTelecom.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.customerDocsTelecom.description")}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/eaa-konkurranseevne-bransjer"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_14}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.eaaCompetitiveness.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.eaaCompetitiveness.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.eaaCompetitiveness.description")}
            </p>
          </div>
        </Link>


        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/helseinformasjon-alle-kan-forsta"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_13}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.healthInformation.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.healthInformation.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.healthInformation.description")}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/fem-steg-universell-utforming-pdf"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_12}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.fiveSteps.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.fiveSteps.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.fiveSteps.description")}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/offentlig-sektor-tilgjengelige-dokumenter"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover object-[30%_30%]"
              src={article_img_11}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.offentligSektor.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.offentligSektor.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.offentligSektor.description")}
            </p>
          </div>
        </Link>
      
        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/digitale-kommunikasjonstrender-2025"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover object-[30%_30%]"
              src={article_img_10}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.digitaleKommunikasjonstrender.description")}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/gjensidige-xper-samarbeid"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full  object-cover mt-[-80px]"
              src={article_img_9}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.gjensidigeXPER.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.gjensidigeXPER.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.gjensidigeXPER.description")}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/gamle-pdf-er-tilgjengelige"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_8}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.gamlePDFerTilgjengelige.description")}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/nav-samarbeid"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_7}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.navCollaboration.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.navCollaboration.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.navCollaboration.description")}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/ccm-for-bank-og-forsikring"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_6}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.bankInsurance.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.bankInsurance.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.bankInsurance.description")}
            </p>
          </div>
        </Link>

      

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/linknordic-partnership"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_5}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.linkNordicPartnership.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.linkNordicPartnership.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.description"
              )}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/kommunikasjon-som-bygger-tillit"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_4}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.ccm.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.ccm.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.ccm.description")}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/tilgjengelighetsdirektivet"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_3}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.edbeu.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.edbeu.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.edbeu.description")}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/gjor-dokumentene-dine-tilgjengelige"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_2}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.pdf.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.pdf.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.pdf.description")}
            </p>
          </div>
        </Link>

        <Link
          className="text-main-dark w-full md:w-1/3 p-6 hover:bg-gray hover:cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
          to="/artikler/er-din-bedrift-klar"
        >
          <div className="w-full aspect-[16/9] bg-white overflow-hidden">
            <img
              className="w-full h-full object-cover"
              src={article_img_1}
              alt=""
            ></img>
          </div>
          <div className="flex flex-col text-left items-start">
            <h2 className="text-2xl font-bold mt-2">
              {i18next.t("pages.articles.list.eaa.title")}
            </h2>
            <p className="text-sm text-secondary mb-0">
              {i18next.t("pages.articles.list.eaa.date")}
            </p>
            <p className="max-w-xs text-md text-secondary line-clamp-2">
              {i18next.t("pages.articles.list.eaa.description")}
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Artikler;
